var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 107,
    viewBox: "0 0 64 107",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4447 40.7486L26.6678 20.0596V101.323C26.6678 102.737 27.2296 104.093 28.2295 105.093C29.2295 106.093 30.5858 106.655 32 106.655C33.4142 106.655 34.7705 106.093 35.7704 105.093C36.7704 104.093 37.3322 102.737 37.3322 101.323V20.0596L54.5553 40.7486C55.4604 41.8375 56.761 42.5223 58.1709 42.6523C59.5809 42.7823 60.9848 42.3469 62.0737 41.4418C63.1627 40.5367 63.8474 39.2361 63.9774 37.8261C64.1074 36.4162 63.672 35.0123 62.7669 33.9234L36.1058 1.93003C35.6055 1.32621 34.9781 0.840175 34.2684 0.50657C33.5587 0.172965 32.7842 0 32 0C31.2158 0 30.4413 0.172965 29.7316 0.50657C29.0219 0.840175 28.3945 1.32621 27.8942 1.93003L1.23307 33.9234C0.784919 34.4625 0.447358 35.0847 0.239656 35.7544C0.0319539 36.424 -0.0418202 37.128 0.0225483 37.8261C0.152546 39.2361 0.837331 40.5367 1.92626 41.4418C3.01519 42.3469 4.41906 42.7823 5.82904 42.6523C7.23902 42.5223 8.53961 41.8375 9.4447 40.7486Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.bec7a7d371b74b51d5349a23d3af1d12.svg";
export { ForwardRef as ReactComponent };